import { RunsheetShiftStatus } from '@/entities/schedules/models/runsheet/RunsheetShift'
import { Icon } from '@/shared/components'
import { faClock } from '@fortawesome/pro-regular-svg-icons'
import { Box, styled, Tooltip } from '@mui/material'

export const getShiftIconFromStatus = (status?: RunsheetShiftStatus, statusTooltip?: string) => {
  if (!status || !statusTooltip) {
    return null
  }

  return (
    <Tooltip title={statusTooltip} placement="bottom" arrow>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <StyledIcon icon={faClock} $status={status} />
      </Box>
    </Tooltip>
  )
}

export const StyledIcon = styled(Icon, {
  shouldForwardProp: (prop) => prop !== '$status',
}) <{ $status?: RunsheetShiftStatus }>`
  color: ${(props) => {
    if (props.$status === 'completed' || props.$status === 'active') {
      return props.theme.palette.success.main
    } else if (props.$status === 'notStarted') {
      return props.theme.palette.warning.main
    } else if (props.$status === 'late') {
      return props.theme.palette.error.main
    }
  }};

  font-size: ${(props) => props.theme.typography.pxToRem(14)};
  margin-left: ${(props) => props.theme.typography.pxToRem(2)};
  margin-right: ${(props) => props.theme.typography.pxToRem(2)};
`